"use client";

import {
  calculateDiscountPercentage,
  formatCurrencyWithSign,
} from "@/lib/utils";
import Image from "next/image";
import React from "react";
import "./FashionProductCard.scss";
import Link from "next/link";
import { usePathname } from "next/navigation";

const FashionProductCard = ({ product, currency }) => {
  const { images, title, sold_out, id, handle, variant_detail } = product;
  const pathname = usePathname();

  const { discounted_price, original_price } = variant_detail;

  const discount =
    discounted_price && discounted_price < original_price
      ? calculateDiscountPercentage(original_price, discounted_price)
      : 0;

  // Determine if we're in men's section
  const isMenSection = pathname.includes("/fashion/men");
  const productLink = isMenSection 
    ? `/fashion/men/${handle}` 
    : `/fashion/${handle}`;

  return (
    <div className="fashion-product-card">
      <div className="image-container">
        <Link href={productLink}>
          <Image
            src={images[0]}
            alt={title}
            width={300}
            height={400}
            className="product-image"
          />
        </Link>

        {sold_out && (
          <div className="sold-out-badge badge">
            <span>Sold Out</span>
          </div>
        )}

        {!sold_out && discount > 0 && (
          <div className="discount-badge badge">
            <span>-{discount}%</span>
          </div>
        )}

        {/* <button className="wishlist-button">
          <CiHeart color="#2F2F2F" size={18} />
        </button> */}
        {/* Add to Cart */}
        {/* <button className="add-to-cart">Add to Cart</button> */}
      </div>

      <Link href={productLink}>
        <h3 className="product-title">{title}</h3>
      </Link>

      <div className="flex items-center gap-2">
        {discount > 0 && (
          <p
            style={{
              textDecoration: "line-through",
            }}
            className="original-price product-price"
          >
            {formatCurrencyWithSign(original_price, currency)}
          </p>
        )}
        <p
          style={{ color: discount > 0 ? "#E32F20" : "#2F2F2F" }}
          className="final-price product-price"
        >
          {formatCurrencyWithSign(discounted_price, currency)}
        </p>
      </div>
    </div>
  );
};

export default FashionProductCard;
